import { LIMITED_LOGS_DAYS, LIMITED_LOGS_DAYS_PRO } from '@api/services/constants';
import { useMobile } from '@api/services/hooks/useMobile';
import { getAccountStore } from '@api/store/account/actions';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

/**
 * @returns dates options for dateDropdown popover
 */
export const useDateDropdownOptions = (hasExtendedLogs?: boolean): any => {
    const { t } = useTranslation();
    const { GeneralInfo } = useSelector(getAccountStore);
    const isMobile = useMobile();
    const limitedDays = GeneralInfo?.KeepLogsForDays === LIMITED_LOGS_DAYS ? LIMITED_LOGS_DAYS : LIMITED_LOGS_DAYS_PRO;

    const calendar = [
        {
            borderBottom: true,
            label: t('specificdaterange') as string,
            value: 'calendar' as string,
        },
    ];
    const dateOptions = [
        {
            borderBottom: false,
            label: t('last24hours') as string,
            value: '1',
        },
        {
            borderBottom: false,
            label: t('lastdays', { days: limitedDays }) as string,
            value: `${limitedDays}`,
        },
        ...(hasExtendedLogs
            ? [
                  {
                      borderBottom: false,
                      label: t('lastdays', { days: 14 }) as string,
                      value: '14',
                  },
                  {
                      borderBottom: false,
                      label: t('lastdays', { days: 35 }) as string,
                      value: '35',
                  },
              ]
            : []),
    ];

    return isMobile ? [...dateOptions.map((o) => ({ ...o, value: `${o.value}` })), ...calendar] : [...calendar, ...dateOptions];
};
